import React from "react";

/*
 * This is here rather than as an svg in the /assets/images folder
 * so that it can fit the same api as all the  other icons as imported from
 * react icons.
 *
 * There were a few things i did to export this.
 *
 * I used svgr https://react-svgr.com/playground/?icon=true&replaceAttrValues=%23F44336%3DcurrentColor
 *
 * Such that i could replace the fill color with "currentColor"
 * This lets the icon take on the color of the currentText.
 *
 * Then i changed the height and width to equal 20px by 20px to match the size of
 * all the other icons so we can
 *
 *
 */
const PosbossCloud = (props) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 190 126"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"Normal"}</title>
      <path
        d="M157.623 44.435C157.623 20.993 138.113 2 114.041 2c-17.354 0-32.298 9.897-39.305 24.186-5.294-3.794-11.77-6.108-18.857-6.108-17.63 0-31.93 13.92-31.93 31.09 0 4.327.918 8.444 2.559 12.192C11.47 65.875 0 78.548 0 93.913 0 111.088 14.298 125 31.933 125h34.878V96.24c-4.473-1.387-7.581-4.216-7.754-7.51l.047-39.168c.163-1.454 1.423-2.594 2.953-2.594 1.53 0 2.786 1.14 2.935 2.594l.014 29.13c.248 1.123 1.309 1.987 2.538 1.987 1.414 0 2.556-1.106 2.573-2.473.01-.058-.008-28.251-.008-28.359 0-1.588 1.32-2.879 2.952-2.879 1.628 0 2.949 1.291 2.949 2.879l.02 28.308c0 1.393 1.16 2.524 2.591 2.524 1.234 0 2.323-.815 2.585-1.935V49.847c.021-1.55 1.317-2.8 2.91-2.8 1.606 0 2.913 1.273 2.913 2.838l.076 38.56c0 3.412-3.151 6.365-7.75 7.795V125h35.134V96.663c-4.664-10.91-10.554-28.769-5.577-48.662 5.288-21.137 17.49-22.49 18.358-16.113l-.038 78.077L127.22 125h25.674c1.208 0 2.402-.066 3.58-.18C175.302 123.062 190 107.64 190 88.868c0-18.68-14.568-34.039-33.253-35.922.568-2.756.876-5.592.876-8.51z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
};
export default PosbossCloud;
